import { observer } from 'mobx-react-lite';
import { ParameterRender } from './ParameterRender';
import { ParametersTable } from './ParametersTable';
import { ParametersGroup } from './ParametersGroup';
import { Parameter } from './Parameter';
import { importComponent } from '../components';
import { ParameterObject, ParametersGroupRenderer } from './types';
import { ReactNode, Suspense } from 'react';
import { ParametersStore } from './ParametersStore';
import { uniqueId } from '@apia/util';

type ParametersMap = Record<string, ParameterObject>;

export const Parameters = observer(
  ({
    label,
    ownerName,
    parameters,
  }: {
    label?: ReactNode;
    ownerName?: string;
    parameters?: ParametersMap;
  }) => {
    const params =
      parameters ??
      ParametersStore.getInstance().getParameters(ownerName ?? '');

    if (!params) return;
    return (
      <>
        {label}
        {Object.entries(params).map(([, c]) => {
          if (c instanceof Parameter) {
            return (
              <ParameterRender
                index={0}
                parameter={c}
                key={uniqueId(c.state.name)}
              />
            );
          } else if (c instanceof ParametersGroup) {
            if (c.component) {
              const Component = importComponent(
                c.component,
              ) as ParametersGroupRenderer;
              return (
                <Suspense fallback={null}>
                  <Component group={c} key={c.name} />
                </Suspense>
              );
            } else {
              return <ParametersTable group={c} key={c.name} />;
            }
          }
        })}
      </>
    );
  },
);
